"use client";
import { useState } from "react";
import ChevronDown from "@/components/icons/chevron-down";
import { cn } from "@/lib/utils";

const BioToggle = ({ bio }: { bio: string }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <p
        className={cn(
          "text-sm leading-5 font-medium",
          !expanded && "line-clamp-3",
        )}
      >
        {bio}
      </p>
      <button
        className="text-brand-blue-600 text-sm font-medium flex items-center gap-1 mt-1"
        onClick={() => setExpanded(!expanded)}
        type="button"
      >
        {expanded ? (
          <>
            Daha Az
            <ChevronDown className="w-4 h-4 rotate-180 stroke-brand-blue-600 fill-none" />
          </>
        ) : (
          <>
            Devamı
            <ChevronDown className="w-4 h-4  stroke-brand-blue-600 fill-none" />
          </>
        )}
      </button>
    </div>
  );
};

export default BioToggle;
